<template>
  <div class="stage-card-progress-bar">
    <div class="header-and-counts">
      <div class="header grey--text text--darken-2">{{ title }}</div>
      <div class="counts grey--text text--darken-1">
        {{ resolvedCount.toLocaleString() }} /
        {{ totalCount.toLocaleString() }}
      </div>
    </div>
    <progress-breakdown :progress-items="items" />
  </div>
</template>

<script>
import ProgressBreakdown from '@/components/Common/ProgressBreakdown';

export default {
  name: 'StageCardProgressBar',
  components: { ProgressBreakdown },
  props: {
    title: {
      type: String,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    otherTooltipPrefix: {
      type: String,
      default: null,
    },
    successTooltipPrefix: {
      type: String,
      default: null,
    },
    successCount: {
      type: Number,
      default: 0,
    },
    lightSuccessTooltipPrefix: {
      type: String,
      default: null,
    },
    lightSuccessCount: {
      type: Number,
      default: 0,
    },
    errorCount: {
      type: Number,
      default: 0,
    },
    errorTooltipPrefix: {
      type: String,
      default: null,
    },
  },
  computed: {
    resolvedCount() {
      return (
        this.successCount + this.lightSuccessCount + this.errorCount
      );
    },
    unresolvedCount() {
      return this.totalCount - this.resolvedCount;
    },
    items() {
      const items = [];
      if (this.successCount > 0) {
        items.push({
          color: 'success',
          count: this.successCount,
          tooltipPrefix: this.successTooltipPrefix,
        });
      }
      if (this.lightSuccessCount > 0) {
        items.push({
          color: 'green lighten-4',
          count: this.lightSuccessCount,
          tooltipPrefix: this.lightSuccessTooltipPrefix,
        });
      }
      if (this.errorCount > 0) {
        items.push({
          color: 'error',
          count: this.errorCount,
          tooltipPrefix: this.errorTooltipPrefix,
        });
      }

      if (this.unresolvedCount > 0) {
        items.push({
          color: 'grey lighten-2',
          count: this.unresolvedCount,
          tooltipPrefix: this.otherTooltipPrefix,
        });
      }

      return items;
    },
  },
};
</script>

<style lang="scss" scoped>
.stage-card-progress-bar {
  display: grid;
  gap: 12px;
}
.header-and-counts {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header {
    font-size: 16px;
    font-weight: 700;
  }

  .counts {
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
